module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/drag-horizontal.svg?973a80a57350413e3569d2beee7c8fcd";